require('../../styles/factbox.scss')
import 'babel-polyfill'
import angular from 'angular';
import ngRoute from 'angular-route';
import ngCookies from 'angular-cookies';
import uibDropdown from 'angular-ui-bootstrap/src/dropdown';
import uibModal from 'angular-ui-bootstrap/src/modal';
import uibProgressbar from 'angular-ui-bootstrap/src/progressbar';

// Application Settings
import factboxAppRoutes from './factbox-app.routes';
import factboxAppRouteChanges from './factbox-app.routechanges';
import factboxAppAuthModal from './factbox-app.auth-modal';
import factboxAppDebug from './factbox-app.debug';
import factboxAppLegacyCompile from './factbox-app.legacy-compile';
import factboxAppExceptions from './factbox-app.exceptions';

// Filters
import LexiconFilter from '../../filters/lexicon';

// Interceptors
import UnauthorizedInterceptor from '../../interceptors/unauthorized';
import ErrorFeedbackInterceptor from '../../interceptors/error-feedback';
import LoadingFeedbackInterceptor from '../../interceptors/loading-feedback';

// Services
import AnalyticsServ from '../../services/analytics';
import BrowserServ from '../../services/browser';

// Modals
import SigninModalConf from '../../modals/signin'

// Models
import ErrorsModel from '../../models/errors';

// Pages
import AccountPage from '../../pages/account';
import DownloadPage from '../../pages/download';
import FactPage from '../../pages/fact';
import ForgotPage from '../../pages/forgot';
import HomePage from '../../pages/home';
import OAuthCompletedPage from '../../pages/oauth-completed';
import ResetPage from '../../pages/reset';
import SigninPage from '../../pages/signin';
import SignupPage from '../../pages/signup';
import TutorialPage from '../../pages/tutorial';
import VerifyPage from '../../pages/verify';
import HelpPage from '../../pages/help';
// import DebugPage from '../../pages/debug';

// Directives
import fbLoading from '../../components/fb-loading';

angular.module('factbox-app', [ngRoute, ngCookies, uibDropdown, uibModal,
    uibProgressbar,
    UnauthorizedInterceptor,
    ErrorFeedbackInterceptor, ErrorsModel, LoadingFeedbackInterceptor,
    AnalyticsServ, BrowserServ,
    HomePage, FactPage, SigninPage, SignupPage, AccountPage,
    DownloadPage, ForgotPage, HelpPage,
    OAuthCompletedPage, ResetPage, TutorialPage, VerifyPage,
    fbLoading, SigninModalConf, LexiconFilter
  ])
  .config(factboxAppRoutes)
  .config(factboxAppDebug)
  .config(factboxAppLegacyCompile)
  .config(factboxAppExceptions)
  .run(factboxAppRouteChanges)
  .run(factboxAppAuthModal)
  .run(['$templateCache', ($templateCache) => {
    $templateCache.put('/modals/default/modal-container.html',
      require('../../modals/default/modal-container.html'));
  }]);



// WEBPACK FOOTER //
// ./project/apps/factbox-app/factbox-app.js